import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-layout',
    templateUrl: './app-layout.component.html'
})
export class AppLayoutComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }
}